import { get } from "lodash";
import { useSelector } from "react-redux";
import { getUserRole } from "../ui/helpers";

export const IsEndUser = () => {
  const user = useSelector(({ auth: { user } }) => user) || {};
  const tenants = get(user, "permissions.tenant", {});

  const isNationalAdmin = get(user, "permissions.is_national_admin");
  const isTenantAdmin = getUserRole("is_tenant_admin", tenants);
  const isEndUser = get(user, "permissions.is_end_user");
  return !isNationalAdmin && !isTenantAdmin && isEndUser;
};

export const isEndUser = (user = {}, tenants = []) => {
  const isNationalAdmin = get(user, "permissions.is_national_admin");
  const isTenantAdmin = getUserRole("is_tenant_admin", tenants);
  const isEndUser = get(user, "permissions.is_end_user");
  return !isNationalAdmin && !isTenantAdmin && isEndUser;
};

export const IsGuest = () => {
  const user = useSelector(({ auth: { user } }) => user) || {};
  const tenants = get(user, "permissions.tenant", {});

  const isNationalAdmin = get(user, "permissions.is_national_admin");
  const isTenantAdmin = getUserRole("is_tenant_admin", tenants);
  const isEndUser = get(user, "permissions.is_end_user");
  return !isNationalAdmin && !isTenantAdmin && !isEndUser;
};

export const IsTenantUser = () => {
  const user = useSelector(({ auth: { user } }) => user) || {};
  const tenants = get(user, "permissions.tenant", {});

  const isNationalAdmin = get(user, "permissions.is_national_admin");
  const isTenantAdmin = getUserRole("is_tenant_admin", tenants);
  const isTenantUser = get(user, "permissions.is_tenant_user");
  return !isNationalAdmin && !isTenantAdmin && isTenantUser;
};
